<script setup lang="ts">
import type { AlgoliaHandleDynamicListingSortingProps } from './AlgoliaHandleDynamicListingSorting.props'

const props = defineProps<AlgoliaHandleDynamicListingSortingProps>()

const { gridConfiguration } = toRefs(props)

const currentAlgoliaIndex = useAppConfig().currentAlgoliaIndex
const { state } = useAisWidget('sortBy')
const { getInstance } = useInstantSearch()
const instance = getInstance()
const route = useRoute()

const initSearch = (index: string, page: number | undefined) => {
  instance.value.helper
    ?.setIndex(index)
    ?.setPage(page ?? 0)
    ?.search()
}

watch(gridConfiguration, (newVal, oldVal) => {
  const page = instance.value.helper?.getPage()
  const currentRefinement = state.value.currentRefinement

  if (newVal === 'gridMoodboard') {
    // Switching TO gridMoodboard: always use dynamic listing
    if (!(route.name! as string)?.includes('preview'))
      initSearch(`dynamic_listing-${currentAlgoliaIndex}`, page)
  } else if (oldVal === 'gridMoodboard') {
    // Switching FROM gridMoodboard to another grid
    if (currentRefinement === `dynamic_listing-${currentAlgoliaIndex}`) {
      // Was using dynamic listing, switch to default index
      initSearch(currentAlgoliaIndex, page)
    } else if (
      currentRefinement !== currentAlgoliaIndex &&
      currentRefinement !== `dynamic_listing-${currentAlgoliaIndex}`
    ) {
      // Was using a custom sort (like price_asc/price_desc), maintain it
      initSearch(currentRefinement, page)
    } else {
      // Default fallback
      initSearch(currentAlgoliaIndex, page)
    }
  }
})
</script>

<template>
  <div></div>
</template>
